import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../config/config';
import Fetch from '../../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../../helpers/chooseProfileFilter';

function Contabilities() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/people/';
    const paths = {
        endpointSave: config.endpoints.backend + 'people/save',
        endpointGetAllPeopleContabilities:
            config.endpoints.backend + 'peoplecontabilities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleEdit: 'Editar Conta Bancária',
        labelTitleView: 'Visualizar Conta Bancária'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id;
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues,
                pdc_people_id: id,
                ...(values?.id && { id: values.id })
            },
            fields: [
                {
                    name: 'minified_code',
                    type: 'text',
                    label: 'Código Reduzido',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'cost_center',
                    type: 'text',
                    label: 'Centro de Custo',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'subsidiary_code',
                    type: 'text',
                    label: 'Código Matriz/Filial',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_iss',
                    type: 'text',
                    label: 'Código Reduzido ISS',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_inss',
                    type: 'text',
                    label: 'Código Reduzido INSS',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_csrf',
                    type: 'text',
                    label: 'Código Reduzido CSRF',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_irrf',
                    type: 'text',
                    label: 'Código Reduzido IRRF',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_discount',
                    type: 'text',
                    label: 'Código Reduzido Desconto',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_fees',
                    type: 'text',
                    label: 'Código Reduzido Juros',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
            ],

            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = await Fetch.post(
                paths.endpointGetAllPeopleContabilities,
                {
                    filter: {
                        pdc_people_id: id
                    }
                }
            );

            if (values.length === 0) {
                values = {
                    contabilities: [{}]
                };
            }


            const form = getForm(values.contabilities[0]);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Contabilities;
